exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".collapse-panel {\n  border-radius: 3px;\n  background-color: #fff;\n  overflow: hidden; }\n\n.header {\n  box-shadow: 0 6px 6px 0 rgba(62, 62, 62, 0.2);\n  cursor: pointer;\n  padding: 1rem;\n  border: 1px solid #ccc; }\n\n.header.space-between {\n  justify-content: space-between; }\n\n.spark-icon {\n  float: right;\n  margin-top: 5px; }\n\n.content {\n  padding: 1.3rem 1rem 1rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/widgets/CollapsePanel/style.scss
// module id = 1381
// module chunks = 0